import { useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

/**
 * Shared hook that opens the Stripe Checkout flow for the Soft Life AI Guide.
 * Returns { loading, buyGuide } — attach buyGuide to any button's onClick.
 */
export function useBuyGuide() {
  const [loading, setLoading] = useState(false);

  const buyGuide = async () => {
    if (loading) return;
    setLoading(true);
    try {
      const origin = window.location.origin;
      const { data } = await api.post("/checkout/session", {
        product_id: "soft-life-ai-guide",
        origin_url: origin,
      });
      if (data.url) {
        // Open Stripe Checkout in a new tab so the user's browsing session on Findaura is preserved.
        const opened = window.open(data.url, "_blank", "noopener,noreferrer");
        if (!opened) {
          // Popup blocked — fall back to a same-tab redirect so the buyer still reaches Stripe.
          window.location.href = data.url;
          return;
        }
        // Reset loading state after tab opens (user is now on Stripe in the new tab).
        setLoading(false);
      } else {
        throw new Error("No checkout URL");
      }
    } catch (e) {
      toast.error("Checkout unavailable. Please try again.");
      setLoading(false);
    }
  };

  return { loading, buyGuide };
}
